// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"21537e4a","455":"5be46a9b","488":"13cebcc0","977":"11c8c081"}[chunkId] + ".chunk.js";
};